import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { CreateUnitFamilyDto, UnitFamilyDto, UpdateUnitFamilyDto } from '@bemum/api-interfaces';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UnitFamilyService {
  constructor(private http: HttpClient) {}

  getList(
    bointerface?: boolean,
    pageIndex?: number,
    pageSize?: number,
    sortField?: string,
    sortOrder?: string,
    textFilter?: string
  ): Observable<UnitFamilyDto[]> {
    let url = `${environment.api_url}/unitFamilys`;
    if (bointerface) url += `?bointerface=${bointerface}`;
    if (pageIndex) url += `&pageIndex=${pageIndex}`;
    if (pageSize) url += `&pageSize=${pageSize}`;
    if (sortField) url += `&sortField=${sortField}`;
    if (sortOrder) {
      const order = sortOrder === 'descend' ? 'DESC' : 'ASC';
      url += `&sortOrder=${order}`;
    }
    if (textFilter) {
      url += `&textFilter=${textFilter}`;
    }
    return this.http.get<UnitFamilyDto[]>(url);
  }

  get(id: string) {
    return this.http.get<UnitFamilyDto>(`${environment.api_url}/unitFamilys/${id}`);
  }

  post(data: CreateUnitFamilyDto): Observable<UnitFamilyDto> {
    return this.http.post<UnitFamilyDto>(`${environment.api_url}/unitFamilys`, data);
  }

  update(id: number, data: UpdateUnitFamilyDto): Observable<UnitFamilyDto> {
    return this.http.patch<UnitFamilyDto>(`${environment.api_url}/unitFamilys/${id}`, data);
  }

  delete(id: number) {
    return this.http.delete(`${environment.api_url}/unitFamilys/${id}`);
  }
}
